module.exports = __webpack_public_path__ + "img/rmrlogo.7a77ade9.png";